module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgement"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Preface"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter01"
    }
  }, [_vm._v("1  THE RETURN OF NATURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2  THE BIRTH OF NATURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  RETURN TO NATURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  RETURN FROM THE NATURE BEYOND NATURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  THE ELEMENTAL TURN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  THE COSMOLOGICAL TURN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7  COMING AS IF FROM NOWHERE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8  THE PLURALITY OF NATURE AND THE DISINTEGRATION OF DIFFERENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("English Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Index02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Greek Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b863104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 75
// module chunks = 0